import React, { useState, useRef } from 'react';
import MathBackground from './components/MathBackground';
import { QRCodeSVG } from 'qrcode.react'; // Правильный импорт
import { FaKaggle, FaTelegram, FaFileAlt } from 'react-icons/fa'
import { FaGithub } from 'react-icons/fa';       // GitHub
import './App.css'; // Правильный импорт

// Дата рождения: 1 марта 2009 (месяцы в JS с нуля)
const BIRTH_DATE = new Date(2009, 2, 1);

function getAge(birth) {
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const hadBirthday =
    now.getMonth() > birth.getMonth() ||
    (now.getMonth() === birth.getMonth() && now.getDate() >= birth.getDate());
  if (!hadBirthday) age--;
  return age;
}

// Главные достижения для About (подобраны вручную)
const HIGHLIGHTS = [
  'Winner of the AI Challenge (AI Journey)',
  'Prize winner of the DLS Olympiad (MIPT)',
  'Prize winner of the Yandex Challenge',
  'Participant of the NEOAI International Olympiad',
];

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const titleRef = useRef(null);
  const aboutRef = useRef(null);

  // Точка гравитации пасхалки E: между надписью Levandox и кнопкой About
  const getGravityCenter = () => {
    if (!titleRef.current || !aboutRef.current) return null;
    const title = titleRef.current.getBoundingClientRect();
    const about = aboutRef.current.getBoundingClientRect();
    return { x: title.left + title.width / 2, y: (title.bottom + about.top) / 2 };
  };

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  // Ссылки на GitHub и Telegram (замените на свои)
  const githubUrl = 'https://github.com/kayumovlev';
  const telegramUrl = 'https://t.me/rndlabs';
  const kaggleUrl = 'https://www.kaggle.com/levkayumov';

  // Общий стиль для кнопок
  const buttonStyle = {
    fontFamily: 'Arial, sans-serif',
    fontSize: '1rem',
    padding: '0.5rem 1rem',
    cursor: 'pointer',
    borderRadius: '5px',
    border: '1px solid #ccc',
    backgroundColor: 'transparent',
    color: '#555',
    transition: 'color 0.3s ease, border-color 0.3s ease',
    outline: 'none',
    margin: '0 0.5rem',
  };
  // Стиль для контейнера QR-кода
  const qrContainerStyle = {
    position: 'absolute',
    top: '20px',
    right: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    zIndex: 2,
  };

  // Стиль для QR-кода
  const qrCodeStyle = {
    // RGBA
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '20px',
    borderRadius: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease',
  };

  // Стиль для подписи
  const labelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '0.9rem',
    color: 'black',
    fontWeight: '500',
    backgroundColor: 'rgba(255,255,255,0.9)',
    padding: '4px 8px',
    borderRadius: '6px',
  };

  // Хендлеры для наведения (чтобы не дублировать код)
  const handleMouseEnter = e => {
    e.currentTarget.style.color = '#000';
    e.currentTarget.style.borderColor = '#000';
  };
  const handleMouseLeave = e => {
    e.currentTarget.style.color = '#555';
    e.currentTarget.style.borderColor = '#ccc';
  };

  return (
    <div style={{ position: 'relative', minHeight: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <MathBackground getGravityCenter={getGravityCenter} />
      {/* QR-код добавлен здесь */}
      <div className="qr-container" style={qrContainerStyle}>
        <div
          style={qrCodeStyle}
        >
          <QRCodeSVG 
            value={telegramUrl}
            size={80}
          />
        </div>
        
        {/* Подпись с иконкой Telegram */}
        <span style={labelStyle}>
          <FaTelegram />
          Telegram Channel
        </span>
      </div>


      {/* Контент */}
      <div
        className="main-card"
        style={{
          position: 'relative',
          zIndex: 1,
          padding: '2rem',
          backgroundColor: 'rgba(255, 255, 255, 0.7)', // полупрозрачный фон
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          textAlign: 'center',
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <h1 ref={titleRef} className="main-title" style={{ fontSize: '4rem', margin: '0 0 1rem 0' }}>Levandox</h1>
        <div>
          <button
            ref={aboutRef}
            onClick={openModal}
            style={buttonStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            About
          </button>
          <a
            href="/cv"
            style={{ ...buttonStyle, display: 'inline-block', textDecoration: 'none' }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            CV
          </a>
        </div>
      </div>

      {/* Модальное окно с блюром и затемнением */}
      {modalOpen && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(5px)',
            WebkitBackdropFilter: 'blur(5px)', // для Safari
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1rem',
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            className="about-modal"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.85)',
              padding: '2rem',
              borderRadius: '10px',
              maxWidth: '600px',
              maxHeight: '80%',
              overflowY: 'auto',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
              textAlign: 'left',
              color: '#222',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              lineHeight: '1.5',
              fontSize: '1.3rem',
            }}
          >
            <h2 className="about-title" style={{ marginTop: 0, marginBottom: '1.5rem', fontWeight: '700', fontSize: '2.8rem', textAlign: 'center' }}>About Me</h2>
            <p style={{ marginBottom: '1rem' }}>
              My name is <strong>Lev Kayumov</strong> (aka <em>Levandox</em>), and I am {getAge(BIRTH_DATE)} y. o.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              I'm an ML researcher and olympiad competitor who's really into math. My end goal is science and R&amp;D. Always happy to talk research, ideas or collabs.
            </p>
            <p style={{ marginBottom: '0.5rem' }}>
              Some of my achievements:
            </p>
            <ul style={{ 
              listStyle: 'disc inside', 
              marginBottom: '1.5rem',
              paddingLeft: '1rem',
              color: '#007bff',
              fontWeight: '600',
              fontSize: '1.2rem',
            }}>
              {HIGHLIGHTS.map(h => (
                <li key={h}>{h}</li>
              ))}
            </ul>
            <p style={{ marginBottom: '1rem' }}>
              And for 8 years, I was engaged in football :)
            </p>
            <div style={{
              display: 'flex',
              padding: '10px',
              justifyContent: 'space-around',
              gap: 'clamp(5px, 2vw, 10px)',
              flexWrap: 'nowrap',
              overflowX: 'hidden'
            }}>
              {[
                { icon: FaGithub, text: 'GitHub', url: githubUrl },
                { icon: FaTelegram, text: 'Telegram', url: telegramUrl },
                { icon: FaKaggle, text: 'Kaggle', url: kaggleUrl },
                { icon: FaFileAlt, text: 'CV', url: '/cv', internal: true }
              ].map(({ icon: Icon, text, url, internal }) => (
                <a
                  key={text}
                  href={url}
                  // внешние ссылки — в новой вкладке, CV — в этой же
                  {...(internal ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
                  className="social-button"
                  style={{ 
                    ...buttonStyle,
                    padding: 'clamp(4px, 1vw, 8px)'
                  }}
                >
                  <span className="social-button-container">
                    <Icon className="social-icon" />
                    <span className="social-button-text">{text}</span>
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
